import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import MultiImageSelect from "../../component/MultiImageSelect";
import AdminHeader from "../../component/AdminHeader";
import { toast } from "react-toastify";


const addCleintLogo = ApiEndpoints.logo.create;
const getCleintLogo = ApiEndpoints.logo.edit;
const deleteCleintLogo = ApiEndpoints.logo.delete;

export default function ClientLogo() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logos, setLogos] = useState([{ _id: "", logo: "" },]);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getCleintLogo,);
      setLogos(response.home_client_logos);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  const handleDelete = async (logo_id) => {
    try {
      const response = await ApiRequest("POST", `${deleteCleintLogo}/${logo_id}`);
      if(response.error === false){
        toast.success(response.message)
        fetchData();
      }else{
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error deleting logo:", error);
    }
  }

  const handleImageChange = async (selectedImages) => {
    const formData = new FormData();
    if (Array.isArray(selectedImages)) {
      selectedImages.forEach((file) => formData.append("logo", file));
    } else {
      formData.append("logo", selectedImages);
    }

    try {
      const response = await ApiRequest("POST", addCleintLogo, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response?.error === false) {
        closeModal();
        toast.success(response.message)
        fetchData();
      }else{
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error uploading image(s):", error);
    }
  };

  const pagename = {
    name: 'Client Logo Management',
    user: 'Admin',
    innerpage: 'Client Logo Management / Client Logos'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="row">
                    {logos.map((logo) => (
                      <div key={logo._id} className="col-lg-2">
                        <div className="home-multi-img">
                          <img src={`${BaseUrl}${logo.logo}`} alt="preview" className="img-responsive" />
                          <button onClick={() => handleDelete(logo._id)} type="button">X</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div onClick={openModal} className="addmore-images-client">Add logos +</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>


      <Modal className="add-modal-area" size="sm" aria-labelledby="contained-modal-title-vcenter" centered show={isModalOpen} onHide={closeModal}>
        <Modal.Body>
          <button className="modal-close-button" onClick={closeModal}>X</button>
          <div className="add-page-inputs">
            <div className="col-lg-12">
              <div className="add-page-sections">Add Client Logo</div>
            </div>
          </div>
          <MultiImageSelect name="casestudy_logo"
            onImageChange={handleImageChange}
            //maxSize={30 * 1024} // 320KB
            acceptedFormats={[".webp"]} />
        </Modal.Body>
      </Modal>
    </>
  )
}
